import {
  SUPERVISOR_USERS_REQUEST,
  SUPERVISOR_USERS_SUCCESS,
  SUPERVISOR_USERS_FAIL,
  SUPERVISOR_MASTER_LIST_REQUEST,
  SUPERVISOR_MASTER_LIST_SUCCESS,
  SUPERVISOR_MASTER_LIST_FAIL,
  SUPERVISOR_MASTER_CREATE_REQUEST,
  SUPERVISOR_MASTER_CREATE_SUCCESS,
  SUPERVISOR_MASTER_CREATE_FAIL,
  SUPERVISOR_MASTER_CREATE_RESET,
  SUPERVISOR_MASTER_UPDATE_REQUEST,
  SUPERVISOR_MASTER_UPDATE_SUCCESS,
  SUPERVISOR_MASTER_UPDATE_FAIL,
  SUPERVISOR_MASTER_UPDATE_RESET,
  SUPERVISOR_MASTER_DELETE_REQUEST,
  SUPERVISOR_MASTER_DELETE_SUCCESS,
  SUPERVISOR_MASTER_DELETE_FAIL,
  SUPERVISOR_MASTER_DELETE_RESET,
  SUPERVISOR_MASTER_UPLOAD_REQUEST,
  SUPERVISOR_MASTER_UPLOAD_SUCCESS,
  SUPERVISOR_MASTER_UPLOAD_FAIL,
  SUPERVISOR_MASTER_UPLOAD_RESET,
} from '../constants/supervisorMasterConstants';

export const supervisorUsersReducer = (state = { supervisors: [] }, action) => {
  switch (action.type) {
    case SUPERVISOR_USERS_REQUEST:
      return { loading: true, supervisors: [] };
    case SUPERVISOR_USERS_SUCCESS:
      return { loading: false, supervisors: action.payload };
    case SUPERVISOR_USERS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const supervisorMasterListReducer = (
  state = { records: [], currentPage: 1, totalPages: 1, totalRecords: 0 },
  action,
) => {
  switch (action.type) {
    case SUPERVISOR_MASTER_LIST_REQUEST:
      return { loading: true, records: [] };
    case SUPERVISOR_MASTER_LIST_SUCCESS:
      return {
        loading: false,
        records: action.payload.records,
        currentPage: action.payload.currentPage,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
      };
    case SUPERVISOR_MASTER_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const supervisorMasterCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case SUPERVISOR_MASTER_CREATE_REQUEST:
      return { loading: true };
    case SUPERVISOR_MASTER_CREATE_SUCCESS:
      return { loading: false, success: true, record: action.payload };
    case SUPERVISOR_MASTER_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case SUPERVISOR_MASTER_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const supervisorMasterUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case SUPERVISOR_MASTER_UPDATE_REQUEST:
      return { loading: true };
    case SUPERVISOR_MASTER_UPDATE_SUCCESS:
      return { loading: false, success: true, record: action.payload };
    case SUPERVISOR_MASTER_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case SUPERVISOR_MASTER_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const supervisorMasterDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case SUPERVISOR_MASTER_DELETE_REQUEST:
      return { loading: true };
    case SUPERVISOR_MASTER_DELETE_SUCCESS:
      return { loading: false, success: true };
    case SUPERVISOR_MASTER_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case SUPERVISOR_MASTER_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

export const supervisorMasterUploadReducer = (state = {}, action) => {
  switch (action.type) {
    case SUPERVISOR_MASTER_UPLOAD_REQUEST:
      return { loading: true };
    case SUPERVISOR_MASTER_UPLOAD_SUCCESS:
      return { loading: false, success: true, uploadResult: action.payload };
    case SUPERVISOR_MASTER_UPLOAD_FAIL:
      return { loading: false, error: action.payload };
    case SUPERVISOR_MASTER_UPLOAD_RESET:
      return {};
    default:
      return state;
  }
};
